import React, { Component } from 'react';
// Composants
import OrganizationSidebar from '../Navbars/OrganizationSidebar';
import SubscriptionRightList from '../Lists/SubscriptionRightList';
import ThemeList from '../Lists/ThemeList';
import CustomFieldList from '../Lists/CustomFieldList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette, faPenField, faAddressCard, faBook, faUserHelmetSafety, faBuilding, faUsers } from '@fortawesome/pro-solid-svg-icons'
import PriceListList from '../Lists/PriceListList';
import BillingAddressForm from '../Forms/Organizations/BillingAddressForm';
import OrganizationMembers from '../Forms/Organizations/OrganizationMembers';
import InfoIcon from '../Utils/InfoIcon';
// Librairies
import { isMobile } from 'react-device-detect';
import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';
import i18n from '../../locales/i18n';
// Redux
import { connect } from 'react-redux';
import { setProject, setViewProjectAsData } from '../../actionCreators/projectsActions';
import { setActiveOrganization } from '../../actionCreators/usersActions';
// Semantic UI
import { Card, Dimmer, Divider, Grid, Loader } from 'semantic-ui-react';
// Services
import SubscriptionsService from '../../services/SubscriptionsService';
import OrganizationsService from '../../services/OrganizationsService';
// Utils
import UsersUtil from '../../utils/UsersUtil';
import OrganizationForm from '../Forms/Organizations/OrganizationForm';
import OrganizationProjects from '../Forms/Organizations/OrganizationProjects';
import StylesUtil from '../../utils/StylesUtil';

const ITEMS = ['general', 'users', 'projects', 'subscription', 'themes', 'customFields', 'priceLists'];

class OrganizationPanel extends Component {
    state = {
        activeItem: 'general',
        isPro: false,
        billingAddress: null,
        externalAuthentications: [],
        linkedAccounts: [],
        userSubscriptionConsumptions: [],
        isLoading: false
    };

    render() {
        const { activeOrganization, logged } = this.props;
        const { activeItem, billingAddress, isPro, userSubscriptionConsumptions } = this.state;

        const nbLinkedUsers = activeOrganization?.linkedUsers?.length || 0;
        const nbInvitations = activeOrganization?.invitations?.filter(i => i.status !== 'declined')?.length || 0;
        const nbMaxUsers = activeOrganization?.subscription?.nbUsers;

        return (
            <Grid textAlign='center' style={{ margin: 0, flexGrow: 1, paddingBottom: isMobile ? 0 : 'var(--spacing-lg)' }} verticalAlign='middle' className='grality-background'>
                {logged ?
                    <>
                        {activeOrganization &&
                            <div className='org-shell'>
                                <div className='auth-header'>
                                    <span className='auth-logo-badge'><FontAwesomeIcon icon={faBuilding} /></span>
                                    <h2 className='auth-title text-light'>{i18n.t("Mon organisation")}</h2>
                                </div>
                                <div className='org-body'>
                                    <OrganizationSidebar activeItem={activeItem} setActiveItem={this.setActiveItem} />
                                    <div className='org-content'>
                                        {activeItem === 'general' &&
                                            <>
                                                <Card className='org-card'>
                                                    <Card.Content>
                                                        <Card.Header className='home-card-head'>
                                                            <span className='home-card-head-icon'><FontAwesomeIcon icon={faBook} /></span>
                                                            {i18n.t("Informations générales")}
                                                        </Card.Header>
                                                        <Divider />
                                                        <OrganizationForm />
                                                    </Card.Content>
                                                </Card>
                                                <Card className='org-card'>
                                                    <Card.Content>
                                                        <Card.Header className='home-card-head'>
                                                            <span className='home-card-head-icon'><FontAwesomeIcon icon={faAddressCard} /></span>
                                                            {i18n.t("Adresse de facturation")}
                                                        </Card.Header>
                                                        <Divider />
                                                        <BillingAddressForm
                                                            subscribing={false} billingAddress={billingAddress}
                                                            setBillingAddress={(ba) => this.setState({ billingAddress: ba })}
                                                            isPro={isPro} setIsPro={(state) => this.setState({ isPro: state })}
                                                        />
                                                    </Card.Content>
                                                </Card>
                                            </>}
                                        {activeItem === 'users' &&
                                            <Card className='org-card'>
                                                <Card.Content>
                                                    <Card.Header className='home-card-head'>
                                                        <span className='home-card-head-icon'><FontAwesomeIcon icon={faUsers} /></span>
                                                        {i18n.t("Membres de l'organisation ({{nbUsers}}/{{nbMaxUsers}})", { nbUsers: nbLinkedUsers + nbInvitations, nbMaxUsers })}
                                                    </Card.Header>
                                                    <Divider />
                                                    <OrganizationMembers />
                                                </Card.Content>
                                            </Card>}
                                        {activeItem === 'projects' &&
                                            <OrganizationProjects userSubscriptionConsumptions={userSubscriptionConsumptions} setUserSubscriptionConsumptions={(usc) => this.setState({ userSubscriptionConsumptions: usc })} />}
                                        {activeItem === 'subscription' && activeOrganization &&
                                            <SubscriptionRightList userSubscriptionConsumptions={UsersUtil.groupUserSubscriptionConsumptionsPerUsers(userSubscriptionConsumptions)} />}
                                        {activeItem === 'themes' && activeOrganization.subscription?.branding &&
                                            <Card className='org-card'>
                                                <Card.Content>
                                                    <Card.Header className='home-card-head'>
                                                        <span className='home-card-head-icon'><FontAwesomeIcon icon={faPalette} /></span>
                                                        {i18n.t("Thèmes")}
                                                    </Card.Header>
                                                    <Divider />
                                                    <ThemeList logged={this.props.logged} />
                                                </Card.Content>
                                            </Card>}
                                        {activeItem === 'customFields' && activeOrganization.subscription?.customFields &&
                                            <Card className='org-card'>
                                                <Card.Content>
                                                    <Card.Header className='home-card-head'>
                                                        <span className='home-card-head-icon'><FontAwesomeIcon icon={faPenField} /></span>
                                                        {i18n.t("Champs personnalisés")}
                                                        <InfoIcon content={
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                <div>{i18n.t("Personnalisez votre expérience en créant vos propres champs, adaptés à vos besoins spécifiques. Ces champs peuvent être utilisés pour enrichir les différents types d'éléments que vous gérez, comme les arbres, les espaces verts ou les mobiliers.")}</div>
                                                                <div>{i18n.t("En plus de cela, vous pouvez organiser ces champs dans des catégories. Par exemple, vous pouvez regrouper plusieurs champs liés à la santé d'un arbre dans une catégorie \"État de l'arbre\" ou créer une catégorie \"Maintenance\" pour vos mobiliers afin de les retrouver plus facilement dans vos projets.")}</div>
                                                            </div>
                                                        } iconStyle={{ marginLeft: '5px' }} popupStyle={{ width: 'min(500px, calc(100vw - 32px))' }} />
                                                    </Card.Header>
                                                    <Divider />
                                                    <CustomFieldList />
                                                </Card.Content>
                                            </Card>}
                                        {activeItem === 'priceLists' && activeOrganization.subscription?.costEstimation &&
                                            <Card className='org-card'>
                                                <Card.Content>
                                                    <Card.Header className='home-card-head'>
                                                        <span className='home-card-head-icon'><FontAwesomeIcon icon={faUserHelmetSafety} /></span>
                                                        {i18n.t("Personnalisation des actions")}
                                                        <InfoIcon content={
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                <div>{i18n.t("Adaptez les actions disponibles dans votre projet en fonction de vos méthodes de travail et de votre nomenclature. Vous pouvez modifier le libellé des actions existantes afin qu'elles correspondent parfaitement à vos habitudes ou à celles de vos équipes terrain.")}</div>
                                                                <div>{i18n.t("Vous avez également la possibilité de définir des tarifs personnalisés pour chaque action, en fonction de critères spécifiques comme la hauteur, la circonférence ou le diamètre de couronne des arbres, ou encore la surface pour les espaces verts. Ces règles vous permettent d'automatiser le calcul des coûts et d'obtenir des estimations précises et cohérentes selon vos propres grilles tarifaires.")}</div>
                                                            </div>
                                                        } iconStyle={{ marginLeft: '5px' }} popupStyle={{ width: 'min(500px, calc(100vw - 32px))' }} />
                                                    </Card.Header>
                                                    <Divider />
                                                    <PriceListList />
                                                </Card.Content>
                                            </Card>}
                                    </div>
                                </div>
                            </div>}
                    </>
                    :
                    <Dimmer active style={StylesUtil.getMapStyles().dimmerStyle}>
                        <Loader content={i18n.t("Chargement en cours...")} />
                    </Dimmer>
                }
            </Grid>
        );
    }

    componentDidMount = () => {
        this.props.changeActiveItem('organizationPanel'); // Sélectionne l'onglet gestion de compte dans la Navbar quand elle est affichée
        this.props.setViewProjectAsData(null);
        this.redirectTimeout = setTimeout(() => this.props.history.push('/'), 2000);
    }

    componentDidUpdate = (prevProps) => { // Si l'utilisateur n'est pas connecté, on l'empêche d'accéder au composant gestion de compte
        const { logged, activeOrganization } = this.props;
        if ((!prevProps.logged && logged) || (logged && this.redirectTimeout !== null))
            if (new Cookies().get('token')) {
                // Chargement de l'adresse de facturation
                OrganizationsService.getBillingAddress().then(billingAddress => {
                    const isPro = (billingAddress?.vat && billingAddress.isValidVat) ? true : false;
                    if (!billingAddress) billingAddress = null;
                    this.setState({ billingAddress: billingAddress, isPro: isPro });
                });

                // Chargement de la consommation de la licence
                SubscriptionsService.getUserSubscriptionConsumptions().then(userSubscriptionConsumptions => this.setState({ userSubscriptionConsumptions }));

                let activeItem = ITEMS.includes(this.props.match.params.category) ? this.props.match.params.category : 'subscription'
                if (['themes', 'customFields', 'priceLists'].includes(activeItem)) {
                    const isActivatedInSubscription = activeItem === 'priceLists' ? activeOrganization?.subscription?.costEstimation : activeOrganization?.subscription?.[activeItem];
                    if (!isActivatedInSubscription) activeItem = 'subscription';
                }

                this.setActiveItem(activeItem);
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = null;
            } else this.props.history.push('/login');

        if (prevProps.logged && !logged) this.props.history.push('/login');

        if (prevProps.activeOrganization?.linkedUsers && this.props.activeOrganization?.linkedUsers && prevProps.activeOrganization.linkedUsers.length < this.props.activeOrganization.linkedUsers.length) {
            const { linkedUsers } = this.props.activeOrganization;
            this.setState(prevState => ({ userSubscriptionConsumptions: prevState.userSubscriptionConsumptions.filter(usc => linkedUsers.find(lu => lu.userId === usc.userId)) }));
        }
    }

    leaveSubscriptionSharing = () => {
        this.setState({ isLoading: true });
        SubscriptionsService.removeUserFromSubscription(jwtDecode(new Cookies().get('token')).id, true).then(activeOrganization => {
            this.props.setActiveOrganization(activeOrganization);
            this.setState({ isLoading: false });
        });
    }

    setActiveItem = (item) => {
        this.setState({ activeItem: item }, () => this.props.history.push(`/organizationPanel/${item}`));
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        activeOrganization: state.activeOrganization,
        tutorialTour: state.tutorialTour,
        loginAsData: state.loginAsData
    };
}

const mapDispatchToProps = {
    setProject,
    setActiveOrganization,
    setViewProjectAsData
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationPanel);
